import { render, staticRenderFns } from "./PrimaryMetricLineIcon.vue?vue&type=template&id=8bc78410&scoped=true"
import script from "./PrimaryMetricLineIcon.vue?vue&type=script&lang=js"
export * from "./PrimaryMetricLineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc78410",
  null
  
)

export default component.exports